<template>
  <div>
    <DetailIndex :orderDeductionCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-order-deduction-expense',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
